export var Methods = /* @__PURE__ */ ((Methods2) => {
  Methods2["Init"] = "init";
  Methods2["AddFileExtension"] = "addFileExtension";
  Methods2["ExtLink"] = "extLink";
  Methods2["File"] = "file";
  Methods2["FirstPartyParams"] = "firstPartyParams";
  Methods2["FirstPartyParamsHashed"] = "firstPartyParamsHashed";
  Methods2["GetClientID"] = "getClientID";
  Methods2["Hit"] = "hit";
  Methods2["NotBounce"] = "notBounce";
  Methods2["Params"] = "params";
  Methods2["ReachGoal"] = "reachGoal";
  Methods2["SetUserID"] = "setUserID";
  Methods2["UserParams"] = "userParams";
  return Methods2;
})(Methods || {});
